interface GetDisputeConfigDTOProps {
  purchaserId: number;
}

export class GetDisputeConfigDTO {
  readonly purchaserId: number;

  constructor(data: GetDisputeConfigDTOProps) {
    this.purchaserId = data.purchaserId;
  }
}
